import Line from "../assets/Linebreak.svg"
import FollowIcon from "../components/Icons/FollowIcon";
import LocationIcon from "../components/Icons/LocationIcon";
import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Spinner from "../components/Shared/Spinner";
import NewsPaperIcon from "../components/Icons/NewsPaperIcon";
import { GetBlogById } from "../api/Blogs/GetBlogById";
import LinkedInIcon from "../components/Icons/LinkedInIcon";
import FacebookIcon from "../components/Icons/FacebookIcon";
import YoutubeIcon from "../components/Icons/YoutubeIcon";
import { Helmet } from 'react-helmet';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw'; // To allow HTML processing

const features = [
    {
        id: 1,
        Icon: LocationIcon,
        title: "Country",
        description: "Republics of Egypt."
    },
    {
        id: 2,
        Icon: NewsPaperIcon,
        title: "Website",
        description: "www.nilewisect.com/"
    },
    {
        id: 3,
        Icon: FollowIcon,
        title: "Follow in",
        description: ""
    },
];

const Blog = () => {

    const { id } = useParams();
    const blogId = id || "";

    const { data: BlogsByIdDTO, isLoading: isBlogLoading } = useQuery({
        queryFn: () => GetBlogById(blogId),
        queryKey: ["blogs", blogId],
        staleTime: 0,
        refetchInterval: 0,
    });
    const blogs = BlogsByIdDTO?.data;


    if (isBlogLoading || !blogs)
        return (
            <div className="min-h-screen flex items-center justify-center">
                <Spinner />
            </div>
        );
        const bioWords = blogs?.instructor?.bio?.split(" ");
        const bioPreview = bioWords?.slice(0, 20).join(" ");
    
    return (
        <>
                  <Helmet>
        <link rel="canonical" href="https://www.nilewisect.com/blogs" />
        <meta name="description" content={blogs?.description} />
                <meta name="title" content={blogs?.title} />
      </Helmet>

                <div className="sm:pt-72 pt-52 mt-1.5">
            <div className="max-w-[1216px] text-center mx-auto">
                <div className="px-4 mb-16 container">
                    <p className="mb-1 font-semibold text-primary sm:text-xl">Blog</p>
                    <h2 className="text-primary font-semibold sm:text-5xl text-28px -tracking-[0.02em]">{blogs?.title} </h2>
                    <p className="mt-4 text-[#808080] sm:text-xl -tracking-[0.02em]">                                    <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                                        {blogs.description}
                                    </ReactMarkdown>
</p>
                </div>
                <div className=" sm:h-[516px] h-[300px] w-full  container sm:mb-32 mb-7">
                    <img src={blogs?.img_url} className="w-full h-full border-black/30 border rounded-[10px]" alt="" />
                </div>
            </div>
            <div className="sm:mb-16 mb-12">
                <img src={Line} className="w-full h-full" alt="" />
            </div>
            <div className="max-w-[720px] mx-auto container">
                <p className="pb-8 border-b border-[#808080] mb-12">{blogs?.brief}</p>
                {blogs?.contents?.map((blog) => (
                    <div className="mb-20 space-y-10">
                        <div>
                            <h2 className="font-semibold text-textSecondary sm:text-[30px] text-2xl mb-6">{blog.title}</h2>
                            <div className="space-y-5 sm:text-lg text-[#808080] sm:mb-16 mb-12">
                                    <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                                        {blog.text}
                                    </ReactMarkdown>
                            </div>
                            {blog.img_url && 
                                                        <div className="sm:h-[351px] h-[300px] w-full">
                                                        <img src={blog.img_url} className="w-full h-full object-fit" alt="" />
                                                    </div>
                        }
                        </div>
                    </div>
                ))}
                <div className="mt-20 flex gap-5 mb-32">
                    <div className=" min-w-1.5 bg-[#076EFF] rounded " />
                    <div>
                        <h1 className="font-bold md:text-2xl sm:text-base text-xs text-textSecondary md:mb-8 mb-4">{bioPreview} <Link to={`/instructor/${blogs?.instructor?.id}`} className="text-[#076EFF]">...Read More</Link></h1>
                        
                        <p className="text-[#808080] sm:text-base text-sm">— <Link to={`/instructor/${blogs?.instructor?.id}`}>{blogs?.instructor?.firstName} {blogs?.instructor?.lastName}</Link>, Professor</p>
                    </div>
                </div>
            </div>

            <div className="max-w-[1216px] mx-auto flex items-center justify-center mb-32 gap-8">
                {features.map(({ id, Icon, title, description }) => (
                    <div className="feature flex flex-col md:items-start items-center basis-1/3 justify-center" key={id}>
                        <div className="bg-[#DBF0FE] w-14 h-14 rounded-full flex items-center justify-center border-8 border-[#EFF9FF] mb-5 hover:border-lightBlue/30 transition-all duration-300 ease-in-out text-primary mx-auto">
                            <Icon />
                        </div>
                        <div className="w-full text-center">
                            <h1 className="mb-2 text-lg md:text-xl font-medium text-[#101828]">{title}</h1>
                            <p className="text-[#475467] md:text-base text-sm">{description}</p>
                            {title === "Follow in" && (
                                <div className="flex gap-5 justify-center items-center">
                                    <Link to="https://www.linkedin.com/company/nilewisect/" target="_blank">
                                        <LinkedInIcon className="text-burntBlack duration-300 transition-all ease-in-out hover:text-primary" />
                                    </Link>
                                    <Link to="https://www.facebook.com/NileWiseCT" target="_blank">
                                        <FacebookIcon className="text-burntBlack duration-300 transition-all ease-in-out hover:text-primary" />
                                    </Link>
                                    <Link to="https://www.youtube.com/@accountingbydr.mohamedisma6604" target="_blank">
                                        <YoutubeIcon className="text-burntBlack duration-300 transition-all ease-in-out hover:text-primary" />
                                    </Link>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
</>
    )
}

export default Blog;
